module.exports = __webpack_public_path__ + "static/media/gallaxy-background.79ecdcd7.jpg";